// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__24X1d","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Qm07"};